package org.hs_soft.runmynesto.domain.model.home.options.cash_flow.app_config_model


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import org.hs_soft.runmynesto.domain.model.general_error_model.GeneralError

@Serializable
data class AppConfigModel(
    @SerialName("data")
    val `data`: Data?,
    @SerialName("errors")
    val errors: List<GeneralError?>?=null,
)